import type { EmailSearchResult } from './types'
import type { Services } from '~/services/types'
import type { DateRange } from 'react-day-picker'
import { DEFAULT_PAGE_SIZE } from './constants'
import { performSearch } from '~common/search-processor'

export interface SearchProcessorServiceDeps {
    getServices: () => Pick<
        Services,
        'googleApi' | 'errorTracker' | 'invoiceProcessor'
    >
}

export class SearchProcessorService {
    constructor(private readonly deps: SearchProcessorServiceDeps) {}

    async searchAndScheduleProcessingEmails(params: {
        terms: string
        dateRange?: DateRange
        dontProcessInvoices?: boolean
        pageSize?: number
        newSearch?: boolean
        searchSubjectOnly?: boolean
        nextPageToken?: string
    }): Promise<EmailSearchResult> {
        params.pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE

        const services = this.deps.getServices()
        const accessToken = services.googleApi.getAccessToken()
        if (!accessToken) {
            throw new Error('Access token not initialized')
        }

        const result = await performSearch({
            terms: params.terms,
            dateRange: params.dateRange,
            nextPageToken: params.newSearch ? undefined : params.nextPageToken,
            pageSize: params.pageSize,
            searchSubjectOnly: params.searchSubjectOnly,
            accessToken: accessToken,
        })

        if (result.parsedMessages.length === 0) {
            return {
                processedEmails: [],
                preProcessedEmails: [],
                nextPageToken: null,
            }
        }

        const processedEmails =
            await services.invoiceProcessor.processEmailsForStorage({
                emails: result.parsedMessages,
                dontProcessInvoices: params.dontProcessInvoices,
            })

        return {
            processedEmails,
            preProcessedEmails: result.parsedMessages,
            nextPageToken:
                result.nextPageToken == null ||
                result.nextPageToken.length === 0
                    ? null
                    : result.nextPageToken,
        }
    }
}
